/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface MultiCurrencyMoney
 */
export interface MultiCurrencyMoney {
    /**
     * Multi currency money.
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof MultiCurrencyMoney
     */
    values?: { [key: string]: MoneyOutput; };
}

/**
 * Check if a given object implements the MultiCurrencyMoney interface.
 */
export function instanceOfMultiCurrencyMoney(value: object): value is MultiCurrencyMoney {
    return true;
}

export function MultiCurrencyMoneyFromJSON(json: any): MultiCurrencyMoney {
    return MultiCurrencyMoneyFromJSONTyped(json, false);
}

export function MultiCurrencyMoneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiCurrencyMoney {
    if (json == null) {
        return json;
    }
    return {
        
        'values': json['values'] == null ? undefined : (mapValues(json['values'], MoneyOutputFromJSON)),
    };
}

export function MultiCurrencyMoneyToJSON(json: any): MultiCurrencyMoney {
    return MultiCurrencyMoneyToJSONTyped(json, false);
}

export function MultiCurrencyMoneyToJSONTyped(value?: MultiCurrencyMoney | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'values': value['values'] == null ? undefined : (mapValues(value['values'], MoneyOutputToJSON)),
    };
}

